import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import { ResponseGetTypeSmartFeed, ResponseGetUserSetting } from "../dto/smartfeed.dto";

@Injectable()
export class SmartfeedNestApi {
  private readonly service: string = '';
  private readonly model: string = 'sf6s/smartfeed';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public typeSmartFeed(param): Observable<ResponseGetTypeSmartFeed> {
    const method: string = 'GET';
    const func: string = 'typeSmartFeed';
    const params: any = {};
    const urlParams: any = {param: param} || {param: {}};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetTypeSmartFeed>(method, url, func, params, body);
  }

  public userSetting(param): Observable<ResponseGetUserSetting> {
    const method: string = 'GET';
    const func: string = 'userSetting';
    const params: any = {};
    const urlParams: any = {param: param} || {param: {}};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetUserSetting>(method, url, func, params, body);
  }

  public saveuserSetting(param) {

    const method: string = 'POST';
    const func: string = 'saveUserSetting';
    const params: any = param || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-all-in-one/services/sf-smartfeed.api.ts